import PropTypes from 'prop-types'

import { AdasBox, AdasTypography, AdasImage } from '@components/wrapper-components'
import CarSkeleton from '../../assets/images/car.svg'

export const CarImageHolder = (props) => {
  const { showText = true } = props
  return (
    <AdasBox>
      <AdasImage className='my-[20px] mx-auto' src={CarSkeleton} alt='holder' />
      {showText && (
        <AdasBox className='flex my-[20px] mx-0 h-[100px] bg-[rgba(26, 27, 31, 0.04)]'>
          <AdasTypography component='span' className='flex items-center m-auto text-base'>
            Enter Vin to fill vehicle details
          </AdasTypography>
        </AdasBox>
      )}
    </AdasBox>
  )
}

CarImageHolder.propTypes = {
  showText: PropTypes.bool
}
